import { tracking } from '@iwoca/frontend-tracking-library';
import { Link } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useNavigate } from 'react-router-dom';

import { getAmplitudeDefaultEventProperties } from '../../../utils/amplitudeEvents';

type TProps = {
  phase: 'intro' | 'question' | 'result';
  questionIndex?: number;
};

export const ExitToSignupLink = ({ phase, questionIndex }: TProps) => {
  const { t } = useLingui();
  const navigate = useNavigate();

  return (
    <Link
      href="/kreditwunsch/neu"
      size="small"
      onClick={(event) => {
        // Client-side nav so the in-memory DE locale survives the handoff;
        // a full reload re-resolves locale from the cookie, which is unset outside .de hosts.
        event.preventDefault();
        tracking.ampli.creditCheckExitedToSignup({
          phase,
          question_index: questionIndex,
          ...getAmplitudeDefaultEventProperties(),
        });
        navigate('/kreditwunsch/neu');
      }}
    >
      {t`Go straight to the application`}
    </Link>
  );
};
